<template>
  <div class="site-shell">
    <site-header />
    <main class="site-main">
      <router-view />
    </main>
    <site-footer />
  </div>
</template>
<script>
import SiteHeader from './components/SiteHeader.vue'
import SiteFooter from './components/SiteFooter.vue'

export default {
  name: 'App',
  components: { SiteHeader, SiteFooter },
  created() {
    this.$store.dispatch('loadBrand').catch(() => {})
    this.$store.dispatch('loadPolicy').catch(() => {})
  },
  watch: {
    '$store.state.brand.primaryColor': {
      immediate: true,
      handler(val) {
        const raw = (val || '').toLowerCase()
        const color = !raw || raw === '#2c5f4e' ? '#1A8CFF' : val
        document.documentElement.style.setProperty('--brand', color)
      }
    }
  }
}
</script>
<style lang="less">
@import './styles/portal.less';
</style>
